import React from 'react';

import { Divider } from '@mui/material';

import classes from './PaymentResultInfo.module.scss';
import { ResultTitle } from '../../../components/payment-result/ResultTitle/ResultTitle';
import { PaymentDetails } from '../../../components/payment-result/PaymentDetails/PaymentDetails';
import { WELCOME_VIDEO_TITLE, WELCOME_VIDEO_URL } from '../../../constants/welcomeVIdeo';
import { VideoBlock } from '../components/VideoBlock/VideoBlock';
import { H20bScaleBlock } from '../components/H20bScaleBlock/H20bScaleBlock';
import { PaymentInfo } from '../../../interfaces/paymentResult';
import { ConsultationType } from '../../../../shared/constants/coach/consultationType';
import {
  SIGN_UP_PAYMENT_RESULT_TYPE,
  SignUpPaymentResultType,
} from '../../../constants/signUpPaymentResultType';
import { ChallengeBlock } from '../components/ChallengeBlock/ChallengeBlock';

type RegistrationPaymentInfoProps = {
  paymentInfo: PaymentInfo;
  consultationType: ConsultationType;
  paymentResultType: SignUpPaymentResultType;
  isNonPaidSubscription: boolean;
  challengeId?: number;
};

const PaymentResultInfo = ({
  paymentInfo,
  consultationType,
  paymentResultType,
  isNonPaidSubscription,
  challengeId,
}: RegistrationPaymentInfoProps) => {
  const titles = {
    [SIGN_UP_PAYMENT_RESULT_TYPE.REGISTRATION]: {
      headTitle: isNonPaidSubscription
        ? '1. Thank You For Signing in'
        : '1. Payment Complete',
      headDescription:
        'Access to the LifeBase app starts when your coach finalizes your setup and custom macro plan.',
      h20bHeadTitle: '2. Purchase H20B InBody Scale',
    },
    [SIGN_UP_PAYMENT_RESULT_TYPE.REACTIVATION]: {
      headTitle: isNonPaidSubscription
        ? 'Thank You For Signing in'
        : 'Thank You For Your Payment!',
      headDescription: "We're attached your receipt to your email",
      h20bHeadTitle: 'Purchase H20B InBody Scale',
    },
  };

  return (
    <div className={classes.container}>
      <ResultTitle
        isSuccessful
        title={titles[paymentResultType].headTitle}
        description={titles[paymentResultType].headDescription}
      />
      <PaymentDetails paymentInfo={paymentInfo} />
      {!challengeId && (
        <>
          <Divider />
          <H20bScaleBlock
            consultationType={consultationType}
            headTitle={titles[paymentResultType].h20bHeadTitle}
          />
        </>
      )}
      {challengeId && (
        <>
          <Divider />
          <ChallengeBlock challengeId={challengeId} />
        </>
      )}
      {paymentResultType === SIGN_UP_PAYMENT_RESULT_TYPE.REGISTRATION && (
        <>
          <Divider />
          <VideoBlock
            title="We're Excited To Help You Reach Your Goals"
            description="Your consultation with your personal nutrition coach is next. Watch the video below to get started."
            videoName={WELCOME_VIDEO_TITLE}
            videoUrl={WELCOME_VIDEO_URL}
          />
        </>
      )}
    </div>
  );
};

export { PaymentResultInfo };
